<template>
  <div>
    <div class="mb-3 richmenu-head">
      <div class="text-center richmenu-head-text">JOBD2U</div>
    </div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 50px; padding-top: 0px">
        <v-img
          style="margin-left: auto; margin-right: auto"
          width="80px"
          src="../../assets/depa.png"
        ></v-img>
      </div>
      <div v-if="loading" class="text-center pt-10">
        <v-progress-circular
          indeterminate
          color="primary"
          size="60"
        ></v-progress-circular>
      </div>
      <v-container v-else class="pt-0">
        <div>ค้นหางาน</div>
        <v-text-field
          v-model="search"
          outlined
          dense
          append-icon="search"
        ></v-text-field>
        <div>ประเภทของงาน</div>
        <v-select
          v-model="jobtype"
          :items="allcategory"
          placeholder="ประเภทของงาน"
          outlined
          dense
          style="border-radius: 6px"
        ></v-select>
        <v-pagination
          v-model="page"
          :length="Math.ceil(filtereddata.length / perPage)"
        ></v-pagination>
        <div
          class="mt-5"
          style="background-color: rgb(247 247 247); border-radius: 6px"
        >
          <div
            @click="showDetailModal(item)"
            v-for="item in visiblePages"
            :key="item._id"
          >
            <div v-ripple class="px-3">
              <v-row class="py-2">
                <v-col cols="3">
                  <v-img
                    lazy-src="@/assets/whiteimg.jpg"
                    width="100%"
                    :src="
                      'https://drive.google.com/uc?export=view&id=' +
                      getIdFromUrl(item.Logo)
                    "
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="15"
                          color="grey"
                        ></v-progress-circular>
                      </v-row>
                    </template> </v-img
                ></v-col>
                <v-col class="pl-0" cols="9">
                  <div style="line-height: 17px; font-size: 15px">
                    <div
                      style="
                        font-weight: bold;
                        font-size: 20px;
                        line-height: 20px;
                        color: #1a3d74;
                      "
                    >
                      {{ item.Position }}
                    </div>
                    <div style="color: #7e7e7e">{{ item.Name }}</div>
                    <div
                      style="
                        color: rgb(34 116 155);
                        font-size: 17px;

                        font-weight: 600;
                      "
                    >
                      {{ item.Salary }}
                    </div>
                    <div style="color: black" class="text-truncate mt-3">
                      {{ item.Details }}
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
          </div>
        </div>
        <v-pagination
          v-model="page"
          :length="Math.ceil(filtereddata.length / perPage)"
        ></v-pagination>
      </v-container>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      fullscreen
      v-model="showdetail"
    >
      <v-card v-if="showdetail">
        <JobDetail
          @close="showdetail = false"
          :data="jobdetaildata"
        ></JobDetail>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import JobDetail from "./JobDetail.vue";
export default {
  components: {
    JobDetail,
  },
  data() {
    return {
      loading: true,
      showdetail: false,
      jobdetaildata: "",
      search: "",
      data: [],
      jobtype: "",
      page: 1,
      perPage: 10,
      allcategory: [],
    };
  },
  async mounted() {
    this.loading = true;
    await this.getJob();
    this.loading = false;
  },
  computed: {
    visiblePages() {
      return this.filtereddata.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
    filtereddata() {
      var result = this.data;
      if (this.jobtype) {
        result = result.filter((el) => el.Type == this.jobtype);
      }
      if (this.search) {
        result = result.filter(
          (el) =>
            el.Position.includes(this.search) || el.Name.includes(this.search)
        );
      }
      this.page = 1;
      return result;
    },
  },
  methods: {
    showDetailModal(item) {
      this.jobdetaildata = item;
      this.showdetail = true;
    },
    getIdFromUrl(url) {
      if (url) {
        return url.match(/[-\w]{25,}/);
      } else {
        return "";
      }
    },
    getJob(category) {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "getlistjobD2U", {
            params: { category },
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              this.data = response.data.data;
              this.allcategory = [
                ...new Set(response.data.data.map((el) => el.Type)),
              ];
              this.allcategory = this.allcategory.filter((el) => el !== null);
              this.jobtype = this.query.category;
            } else {
              this.$swal.fire({
                text: response.data.reason,
              });
            }
            resolve();
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>